import { AdminOverview, AdminMessagesResponse, CopilotAnalytics } from "@/types";
import { apiClient } from "@/lib/apiClient";

/**
 * Admin Service
 * Handles admin-related API calls
 */
export const adminService = {
  /**
   * Get admin overview statistics
   */
  getOverview: async (): Promise<AdminOverview> => {
    return apiClient.get<AdminOverview>("/api/admin/overview");
  },

  /**
   * Get employee chat messages for admin review
   * @param page - Page number (default: 1)
   * @param limit - Items per page (default: 10)
   * @param userId - Optional user ID to filter messages
   */
  getMessages: async (
    page = 1,
    limit = 10,
    userId?: string
  ): Promise<AdminMessagesResponse> => {
    const params: Record<string, string> = {
      page: page.toString(),
      limit: limit.toString(),
    };
    if (userId) {
      params.userPid = userId;
    }
    return apiClient.get<AdminMessagesResponse>("/api/admin/messages", { params });
  },

  /**
   * Get copilot usage and tool reliability for the last `days` days.
   * Derived server-side from stored chat messages — no separate tracking.
   */
  getCopilotAnalytics: async (days = 30): Promise<CopilotAnalytics> => {
    return apiClient.get<CopilotAnalytics>("/api/admin/copilot-analytics", {
      params: { days: days.toString() },
    });
  },
};
